import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarSpecService {

  constructor(private http: HttpClient) { }

  loadBasket(): any {
    return this.http.get<any>(environment.carSpecEndpoint);
  }
}
